<template>
  <div>
    <quill-editor
        :content="editorData"
        :options="editorOption"
        :editor-toolbar="customToolbar"
        @change="onEditorChange($event)"
    />
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  components: {
  },
  name: "Editor",
  props: {
    content: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      editorData: this.content,
      editorOption: {
        spellcheck: false,
      },
      customToolbar: [
      ]
    }
  },

  methods: {
    ...mapActions('vobDocuments', ['prepareContent']),
    onEditorChange({ html }) {
      this.prepareContent(html);
    }
  },

  mounted() {
    this.prepareContent(this.editorData);
  },

  beforeDestroy() {
  },
}
</script>

<style src="./Editor.scss" lang="scss"></style>
